// src/index.ts
import { detectDupes } from "@liveblocks/core";

// src/version.ts
var PKG_NAME = "@liveblocks/client";
var PKG_VERSION = "2.24.2";
var PKG_FORMAT = "esm";

// src/index.ts
import {
  createClient,
  getMentionedIdsFromCommentBody,
  isNotificationChannelEnabled,
  LiveblocksError,
  LiveList,
  LiveMap,
  LiveObject,
  shallow,
  stringifyCommentBody,
  toPlainLson
} from "@liveblocks/core";
detectDupes(PKG_NAME, PKG_VERSION, PKG_FORMAT);
export {
  LiveList,
  LiveMap,
  LiveObject,
  LiveblocksError,
  createClient,
  getMentionedIdsFromCommentBody,
  isNotificationChannelEnabled,
  shallow,
  stringifyCommentBody,
  toPlainLson
};
//# sourceMappingURL=index.js.map